/** Mirrors backend ``MIN_PASSWORD_LENGTH`` / ``password_policy`` (except common-password list). */

export const PASSWORD_MIN_LENGTH = 12;

const HAS_LOWER = /[a-z]/;
const HAS_UPPER = /[A-Z]/;
const HAS_DIGIT = /\d/;
const HAS_SPECIAL = /[^A-Za-z0-9]/;

export type PasswordRuleId = "minLength" | "mixedCase" | "digit" | "special";

export function evaluatePasswordRules(
  password: string | null | undefined,
): Record<PasswordRuleId, boolean> {
  const value = password ?? "";
  return {
    minLength: value.length >= PASSWORD_MIN_LENGTH,
    mixedCase: HAS_LOWER.test(value) && HAS_UPPER.test(value),
    digit: HAS_DIGIT.test(value),
    special: HAS_SPECIAL.test(value),
  };
}
